/**
 * UserRelationGetRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { UserRelationData } from './user_relation_data'

/**
 * UserRelationGetRes
 */
export interface UserRelationGetRes {
  /** 用户关系详情 */
  items?: UserRelationData[]
}

/**
 * UserRelationGetRes Schema
 */
export const UserRelationGetResSchema: SchemaDefinition = {
  properties: {
    items: {
      description: '用户关系详情',
      format: '[]*model.UserRelationData',
      items: { $ref: 'UserRelationData', description: '' },
      type: 'array',
      label: '用户关系详情',
    },
  },
  type: 'object',
}
